<div class="toolbar">
    <span>{{userName}}</span>    
</div>
